import * as Sentry from "@sentry/react";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: "https://dc35a08825bbf364674a20831827e6a2@o4510035461472256.ingest.de.sentry.io/4510035563380816",
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration()
    ],
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT ?? "development",
    tracesSampleRate: 1.0,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/api\.(staging\.)?bonisoft\.de\/api/
    ]
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Suspense fallback="">
      <App />
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
